import styled from 'styled-components';
import { Input, Select, Spin } from '../../../../components/ds';
import { Form } from 'components/ds';

export const CustomInput = styled(Input)``;
export const CustomSelect = styled(Select)``;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`;

export const FormFields = styled.div`
  flex: 1;
  overflow-y: auto; // Adds scrolling if content is too long
`;

export const FormFooter = styled.div`
  margin-top: auto;
  position: sticky;
  bottom: 0;
  background-color: var(--color-background-container);
  padding-top: 16px;

  @media (max-width: 1280px) {
    padding-top: var(--spacing-small);
  }
`;

export const ProgressStepperWrapper = styled.div`
    margin-bottom: var(--spacing-regular);
    margin-top: var(--spacing-regular);
`;

export const OptionalStepContainerStyled = styled.div`
  margin-bottom: 20px;
  padding: 10px;
  border-radius: 10px;
  background-color: var(--color-neutral-light-lighter);
  border: var(--border-width, 1px) solid var(--color-border);
`;

export const LoadingSpin = styled(Spin)`
  margin-bottom: 65px;
`;
